export class ReserveScoutCensusSummaryForm {
    public comment

    constructor({
        comment: comment,
    }: {
        comment?: string,
    }) {
        this.comment = comment
    }
}
